import React from 'react';
import { Form } from 'antd';
import CustomerTextInput from '../../inputs/customerTextInput/CustomerTextInput';
import useTranslation from '../../../hooks/translation/useTranslation';
import CustomerPhoneInputFormatted from '../../inputs/customerPhoneInputFormatted/CustomerPhoneInputFormatted';

function ProfileForm({ form }) {
  const { trans, currentLanguage, configInfo } = useTranslation();
  const address = Form.useWatch('address', form);

  const isGeorgian = configInfo?.countryCode === 'GE';

  return (
    <Form form={form} layout="vertical">
      <div className="flex gap-1 flex-col lg:flex-row lg:gap-4">
        <CustomerTextInput
          disabled
          className="flex-[2]"
          label={trans('country')}
          name={`country_${currentLanguage === 'am' ? 'ka' : currentLanguage}`}
        />
        <CustomerTextInput
          disabled
          className="flex-[2]"
          label={trans(isGeorgian ? 'identification_number' : 'passport_number')}
          name="id_number"
        />
        {address ? (
          <CustomerTextInput
            disabled
            className="flex-[3]"
            label={trans('address')}
            name="legal_address"
          />
        ) : <div className="flex-[3]" />}
      </div>
      <div className="flex gap-1 flex-col lg:flex-row lg:gap-4">
        <CustomerPhoneInputFormatted
          disabled
          className="flex-[2]"
          label={trans('phone_number')}
          name="phone_number"
        />
        <CustomerTextInput
          disabled
          className="flex-[2]"
          label={trans('email')}
          name="email"
        />
        <div className="flex-[3]" />
      </div>
    </Form>
  );
}

export default ProfileForm;
